import { useMutation } from "@tanstack/react-query";
import { api } from "../lib/api";

interface RefreshScheduleParams {
  fhirUrl: string;
  specificDate: string | null;
  sta3n: string;
}

export interface RefreshScheduleResponse {
  appointments_found: number;
  new_patients_added: number;
  patients_reactivated: number;
  appointments_cancelled: number;
  appointments_scheduled_elsewhere: number;
  appointments_cancelled_at_current_facility: number;
  appointments_skipped: number;
  processing_time: string;
  [key: string]: unknown;
}

export function useRefreshSchedule() {
  return useMutation({
    mutationFn: async ({ fhirUrl, specificDate, sta3n }: RefreshScheduleParams) => {
      return api.post<RefreshScheduleResponse>("/va/refresh-pull", {
        url: fhirUrl,
        specific_date: specificDate,
        sta3n,
      });
    },
  });
}

export default useRefreshSchedule;
